import React, { useState, useEffect } from "react";
import "./Chatbot.css";


// ✅ All services
const PRODUCTS = [
  "Web Development",
  "UI/UX Design",
  "Mobile App Development",
  "SEO Optimization",
  "Hosting & Maintenance",
  "AI bot Development",
  "ML model Development",
  "Predictive Sales Analytics",
  "Customer Retention System",
  "Multilingual Chat Support System",
];

// ✅ Sector → services mapping
const sectorToProducts = (sector) => {
  switch ((sector || "").toLowerCase()) {
    case "it":
      return [
        "Web Development",
        "UI/UX Design",
        "Mobile App Development",
        "AI bot Development",
        "ML model Development",
        "Hosting & Maintenance",
      ];
    case "finance":
      return [
        "Web Development",
        "Predictive Sales Analytics",
        "Customer Retention System",
        "Hosting & Maintenance",
      ];
    case "healthcare":
      return [
        "Web Development",
        "Mobile App Development",
        "AI bot Development",
        "ML model Development",
        "Customer Retention System",
        "Hosting & Maintenance",
      ];
    case "education":
      return [
        "Web Development",
        "Mobile App Development",
        "AI bot Development",
        "ML model Development",
        "Multilingual Chat Support System",
        "Hosting & Maintenance",
      ];
    case "retail":
      return [
        "Web Development",
        "Mobile App Development",
        "SEO Optimization",
        "Predictive Sales Analytics",
        "Customer Retention System",
        "Multilingual Chat Support System",
        "Hosting & Maintenance",
      ];
    default:
      return PRODUCTS;
  }
};

// ✅ Budget filter
const filterByBudget = (products, budget) => {
  if (!budget) return products;
  if (budget === "<₹30,000") { 
    return products.filter((p) =>
      ["SEO Optimization", "Hosting & Maintenance", "Multilingual Chat Support System"].includes(p)
    );
  }
  if (budget === "₹30,001-₹80,000") { 
    return products.filter((p) =>
      [
        "Web Development",
        "UI/UX Design",
        "SEO Optimization",
        "Multilingual Chat Support System",
        "Customer Retention System",
      ].includes(p)
    );
  }
  if (budget === "₹80,001-₹1,00,000") {
    return products.filter((p) =>
      [
        "Web Development",
        "UI/UX Design",
        "Mobile App Development",
        "AI bot Development",
        "Customer Retention System",
      ].includes(p)
    );
  }
  return products; // >$10000 → show all
};

// ------------------
// ✅ Translations (keep your same object)
// ------------------
const translations = {
  en: {
    welcome: "👋 Hi there! I’m Rika, your virtual chat assistant. I’m here to help you with anything you need. Let’s get started — what’s your company name ?",
    email: "Could you please provide your email so we can proceed?",
    phone: "Could you please share your 10-digit cellphone number?",
    sector: "Select your sector:",
    budget: "Could you please choose your budget ? ",
    services: "Using your information, we recommend the following services:",
    date: "Choose a date (next 4 weekdays):",
    time: "Select a time slot (10am–5pm):",
    confirm: "Great! Confirm your meeting:",
    yes: "Yes",
    back: "⬅ Back",
    next: "Next",
    sendEmail: "📧 Send Confirmation Email",
    open: "May I help you ? 💬",
    close: "✖ ",
    mobileError: "❌ Invalid number, enter again",
    emailError:"❌ Invalid E-mail, enter again",
    emailSubject: (company) => `Requesting for confirmation of meeting – ${company}`,
    emailBody: (a) => `
Hello,

I hope this message finds you well. I am writing to kindly confirm our scheduled meeting on 
[${a.date}] at [${a.time}] regarding [${a.services.map((s) => `• ${s}`).join("\n")}].

📌 COMPANY INFORMATION
• COMPANY: ${a.company}
• EMAIL: ${a.email}
• PHONE: ${a.phone}

🏢 BUSINESS DETAILS
• SECTOR: ${a.sector}
• BUDGET: ${a.budget}

💡 SUGGESTED SERVICES
${a.services.map((s) => `• ${s}`).join("\n")}

📅 MEETING SCHEDULE
• DATE: ${a.date}
• TIME: ${a.time}

We look forward to connecting with you.

Best Regards,  
${a.company}
    `,
  },

  hi: {
    welcome: "👋 नमस्ते! मैं रिका, आपकी वर्चुअल चैट सहायक हूँ। मैं आपकी हर ज़रूरत में मदद करने के लिए यहाँ हूँ। चलिए शुरू करते हैं — आपकी कंपनी का नाम क्या है ?",
    email: "क्या आप कृपया अपना ईमेल प्रदान कर सकते हैं ताकि हम आगे बढ़ सकें?",
    phone: "क्या आप कृपया अपना 10 अंकों का मोबाइल नंबर साझा कर सकते हैं?",
    sector: "क्या आप कृपया उस क्षेत्र का चयन करेंगे जिसमें आपका व्यवसाय काम करता है?",
    budget: "क्या आप कृपया अपना बजट चुन सकते हैं ?",
    services: "आपकी जानकारी का उपयोग करते हुए, हम निम्नलिखित सेवाओं की सिफारिश करते हैं:",
    date: "तारीख चुनें (अगले 4 कार्य दिवस):",
    time: "समय स्लॉट चुनें (सुबह 10 बजे से शाम 5 बजे तक):",
    confirm: "बहुत बढ़िया! अपनी बैठक की पुष्टि करें:",
    yes: "हाँ",
    back: "⬅ पिछला",
    next: "आगे बढेt",
    sendEmail: "📧 ईमेल से पुष्टि भेजें",
    open: "क्या मैं आपकी मदद कर सकता हूँ ? 💬",
    close: "✖ ",
    mobileError: "❌ अमान्य नंबर, कृपया फिर से दर्ज करें।",
    emailError:"❌ अमान्य ई-मेल, कृपया फिर से दर्ज करें।",
    emailSubject: (company) => `बैठक की पुष्टि के लिए अनुरोध – ${company}`,
    emailBody: (a) => `
नमस्ते,

आशा है आप स्वस्थ और सकुशल होंगे। मैं यह विनम्रतापूर्वक पुष्टि करना चाहता हूँ कि हमारी तय
 बैठक [${a.date}] को [${a.time}] पर [${a.services.map((s) => `• ${s}`).join("\n")}] के संबंध में है।

📌 कंपनी की जानकारी
• कंपनी: ${a.company}
• ईमेल: ${a.email}
• फ़ोन: ${a.phone}

🏢 व्यवसाय विवरण
• क्षेत्र: ${a.sector}
• बजट: ${a.budget}

💡 सुझाई गई सेवाएँ
${a.services.map((s) => `• ${s}`).join("\n")}

📅 बैठक का समय
• दिनांक: ${a.date}
• समय: ${a.time}

हम आपसे मिलने की प्रतीक्षा कर रहे हैं।

शुभकामनाएँ,  
${a.company}
    `,
  },

  mr: {
    welcome: "👋 नमस्कार! मी रिका, तुमची व्हर्च्युअल चॅट सहाय्यक आहे. तुम्हाला ज्या गोष्टीत मदत हवी असेल त्यासाठी मी येथे आहे. चला सुरुवात करूया — तुमच्या कंपनीचं नाव काय आहे ?",
    email: "कृपया आपला ई-मेल द्या म्हणजे आपण पुढे जाऊ शकू ?",
    phone: "कृपया आपला 10 अंकी मोबाइल नंबर शेअर करू शकाल का?",
    sector: "कृपया आपण ज्या क्षेत्रात व्यापारी असाल ते निवडा?",
    budget: "कृपया तुमचा बजेट निवडा:",
    services: "तुमच्या माहितीचा वापर करून, आम्ही खालील सेवा सुचवत आहोत:",
    date: "तारीख निवडा (पुढील 4 कार्य दिवस):",
    time: "वेळ निवडा (सकाळी 10 ते संध्याकाळी 5):",
    confirm: "छान! तुमची बैठक निश्चित करा:",
    yes: "होय",
    back: "⬅ मागे",
    next: "पुढे चला",
    sendEmail: "📧 ईमेलने पुष्टी पाठवा",
    open: " मी तुम्हाला मदत करू का ?💬",
    close: "✖",
   mobileError: "❌ अवैध क्रमांक, कृपया पुन्हा प्रविष्ट करा.",
   emailError:"❌ अवैध ई-मेल, कृपया पुन्हा प्रविष्ट करा.",
    emailSubject: (company) => `बैठकीच्या पुष्टीसाठी विनंती – ${company}`,
    emailBody: (a) => `
नमस्कार,

मला आशा आहे की आपण सुखरूप असाल. आपण ठरवलेली आपली बैठक
 [दिनांक : ${a.date}] रोजी [वेळ : ${a.time}] वाजता [बैठकीचा विषय : ${a.services.map((s) => `• ${s}`).join("\n")}
] संदर्भात आहे, याची मी नम्रपणे पुष्टी करू इच्छितो.

📌 कंपनी माहिती
• कंपनी: ${a.company}
• ईमेल: ${a.email}
• फोन: ${a.phone}

🏢 व्यवसाय माहिती
• क्षेत्र: ${a.sector}
• बजेट: ${a.budget}

💡 सुचवलेल्या सेवा
${a.services.map((s) => `• ${s}`).join("\n")}

📅 बैठक वेळापत्रक
• दिनांक: ${a.date}
• वेळ: ${a.time}

लवकरच भेटूया.

धन्यवाद,  
${a.company}
    `,
  },

  fr: {
    welcome: "👋 Bonjour ! Je suis Rika, votre assistante virtuelle de chat. Je suis là pour vous aider dans tout ce dont vous avez besoin. Commençons — quel est le nom de votre entreprise ?",
    email: "Pourriez-vous s'il vous plaît fournir votre e-mail afin que nous puissions procéder ?",
    phone: "Pourriez-vous s'il vous plaît partager votre numéro de portable à 10 chiffres ?",
    sector: "Pourriez-vous s'il vous plaît choisir le secteur avec lequel votre entreprise est en relation ?",
    budget: "Pourriez-vous s'il vous plaît choisir votre budget ?",
    services: "En utilisant vos informations, nous recommandons les services suivants :",
    date: "Choisissez une date (4 prochains jours ouvrables) :",
    time: "Sélectionnez un créneau (10h–17h) :",
    confirm: "Parfait ! Confirmez votre réunion :",
    yes: "Oui",
    back: "⬅ Retour",
    next: "Next",
    sendEmail: "📧 Envoyer la confirmation par e-mail",
    open: "Puis-je vous aider ? 💬 ",
    close: "✖ ",
    help:"Hello, may I help you ?",
    mobileError: "❌ Numéro invalide, veuillez saisir à nouveau.",
    emailError:"❌ E-mail invalide, veuillez saisir à nouveau.",
    emailSubject: (company) => `Confirmation de réunion – ${company}`,
    emailBody: (a) => `
Bonjour,

J’espère que vous allez bien. Je souhaite confirmer notre réunion prévue 
le [${a.date}] à [${a.time}] concernant [${a.services.map((s) => `• ${s}`).join("\n")}
].

📌 INFORMATIONS SUR L'ENTREPRISE
• ENTREPRISE: ${a.company}
• EMAIL: ${a.email}
• TÉLÉPHONE: ${a.phone}

🏢 DÉTAILS COMMERCIAUX
• SECTEUR: ${a.sector}
• BUDGET: ${a.budget}

💡 SERVICES SUGGÉRÉS
${a.services.map((s) => `• ${s}`).join("\n")}

📅 PLANIFICATION DE LA RÉUNION
• DATE: ${a.date}
• HEURE: ${a.time}

Nous sommes impatients de vous rencontrer.

Cordialement,  
${a.company}
    `,
  },
};

// ✅ Helper: Next 4 weekdays
function getNextWeekdays() {
  const result = [];
  const today = new Date();
  let count = 0;
  let day = 1;
  while (count < 4) {
    const d = new Date(today);
    d.setDate(today.getDate() + day);
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) {
      result.push(d.toDateString());
      count++;
    }
    day++;
  }
  return result;
}

// ------------------
// ✅ Main Chatbot
// ------------------
export default function Chat() {
  const [lang, setLang] = useState("en");
  const t = translations[lang];
 const [error, setError] = useState("");

 const [phone, setPhone] = useState("");

 const [email,setEmail] = useState("");

  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [typing, setTyping] = useState(true);
  const [answers, setAnswers] = useState({
    company: "",
    email: "",
    phone: "",
    sector: "",
    budget: "",
    services: [],
    date: "",
    time: "",
  });

  const times = [
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
  ];
  const dates = getNextWeekdays();

  useEffect(() => {
    setTyping(true);
    const timer = setTimeout(() => setTyping(false), 1000);
    return () => clearTimeout(timer);
  }, [step, lang]);

  // ✅ Step handler
  const handleNext = (field, value) => {
    let updated = { ...answers, [field]: value };

    // After budget selection → generate service suggestions
    if (field === "budget" && answers.sector) {
      const sectorServices = sectorToProducts(answers.sector);
      updated.services = filterByBudget(sectorServices, value);
    }

    setAnswers(updated);
    setStep(step + 1);
  };

  const handleBack = () => {
    if (step > 0) setStep(step - 1);
  };

  // ✅ Email integration
  const sendEmail = () => {
    const subject = t.emailSubject(answers.company);
    const body = t.emailBody(answers);

    const mailtoLink = `mailto:info@aarvek.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=info@aarvek.com&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href = mailtoLink; // Mobile → default mail app
    } else {
      window.open(gmailLink, "_blank"); // Desktop → Gmail web
    }
  };

  const renderBotMessage = (text) => (
    <div className="bot-bubble">
      {typing ? <span className="typing">...</span> : text}
    </div>
  );

  // ✅ UI
  return (
    <div className="chatbot-container">
      {!open && (
        <button className="floating-btn" onClick={() => setOpen(true)}>
          {t.open}
          
        </button>
      )}
      {open && (
        <div className="chat-window">
          <div className="chat-header">
            <h3 className="chat-title"> 🙋 Rika </h3>
            <div className="header-controls">
              <select
                value={lang}
                onChange={(e) => setLang(e.target.value)}
                className="lang-btn"
              >
                <option value="en">🌐 English</option>
                <option value="hi"> हिंदी</option>
                <option value="mr"> मराठी</option>
                <option value="fr"> Français</option>
              </select>
              <button className="close-btn" onClick={() => setOpen(false)}>
                X
              </button>
            </div>
          </div>
          <div className="chat-body">
            {step === 0 && (
              <>
              
                {renderBotMessage(t.welcome)}
                
                {!typing && (
                  <>
                  <input
                    type="text"
                    placeholder="Company name"
                    onKeyDown={(e) =>
                      e.key === "Enter" && handleNext("company", e.target.value)
                    }
                  />
                  <button onClick={handleNext}>{t.next}</button>
                  </>
                )}
              </>
            )}

            {step === 1 && (
  <>
    
    {renderBotMessage(t.email)}

    {!typing && (
      <>
        <input
          type="email"
          placeholder="example@mail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (e.target.value.includes("@")) {
                handleNext("email", e.target.value);
                setError("");
              } else {
                setError(t.emailError);
              }
            }
          }}
        />

        <button
          onClick={() => {
            if (email.includes("@")) {
              handleNext("email", email);
              setError("");
            } else {
              setError(t.emailError);
            }
          }}
        >
          {t.next}
        </button>

        {error && <p style={{ color: "red" }}>{error}</p>}
      </>
    )}
  </>
)}

            {/*{step === 1 && (
              <>
                {renderBotMessage(t.email)}
                {!typing && (
                  <>
                  <input
                    type="email"
                    placeholder="example@mail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) =>{
                      if(e.key === "Enter"){
                        if(e.target.value.includes("@")){
                          handleNext("email", e.target.value)
                        } else {
                           setError(t.emailError);
                        }
                      }
                    }
                       
                      
                    }
                  />

                  <button onClick={()=>{
                     if(e.key === "Enter"){
                        if(e.target.value.includes("@")){
                          handleNext("email", e.target.value)
                        } else {
                           setError(t.emailError);
                        }
                      }
                  }}>{t.next}</button>

                  {error && <p style={{ color: "red" }}>{error}</p>}
                  </>
                )}
              </>
            )}*/}

            {step === 2 && (
  <>
    {renderBotMessage(t.phone)}

    {!typing && (
      <>
        <input
          type="tel"
          placeholder="10-digit number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (/^\d{10}$/.test(e.target.value)) {
                handleNext("phone", e.target.value);
                setError("");
              } else {
                setError(t.mobileError);
              }
            }
          }}
        />

        <button className="-btn"
          onClick={() => {
            if (/^\d{10}$/.test(phone)) {
              handleNext("phone", phone);
              setError("");
            } else {
              setError(t.mobileError);
            }
          }}
        >
          {t.next}
        </button>

        {error && <p style={{ color: "red" }}>{error}</p>}
      </>
    )}
  </>
)}

      { /*     {step === 2 && (
              
              <>
                {renderBotMessage(t.phone)}
                
                {!typing && (
                  <>
                  <input
                    type="tel"
                    placeholder="10-digit number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    onKeyDown={(e) =>{
                      if(e.key === "Enter") {
                      if(/^\d{10}$/.test(e.target.value)) {
                      handleNext("phone", e.target.value)
                      setError("");
                    } else {
                      setError(t.mobileError);
                    }
                  }
                }

                    }
                      
                  />
                  <button onClick={()=>{
                     if(/^\d{10}$/.test(e.target.value)) {
                      handleNext("phone", e.target.value)
                      setError("");
                    } else {
                      setError(t.mobileError);
                    }
                  }} >{t.next}</button>
                  </>
                )}
              </>
            )}*/}
            {step === 3 && (
              <>
                {renderBotMessage(t.sector)}
                {!typing && (
                  <select onChange={(e) => handleNext("sector", e.target.value)}>
                    <option value="">--select--</option>
                    {["IT", "Finance", "Healthcare", "Education", "Retail"].map(
                      (s, i) => (
                        <option key={i}>{s}</option>
                      )
                    )}
                  </select>
                )}
              </>
            )}
            {step === 4 && (
              <>
                {renderBotMessage(t.budget)}
                {!typing && (
                  <select onChange={(e) => handleNext("budget", e.target.value)}>
                    <option value="">--select--</option>
                    {[">₹30,000","₹30,001-₹80,000","₹80,001-₹1,00,000", "<₹1,00,001"].map(
                      (b, i) => (
                        <option key={i}>{b}</option>
                      )
                    )}
                  </select>
                )}
              </>
            )}
            {step === 5 && (
              <>
                {renderBotMessage(t.services)}
                {!typing && (
                  <div className="services">
                    {answers.services.map((s, i) => (
                      <div key={i} className="suggested-service">
                        {s}
                      </div>
                    ))}
                    <button onClick={() => setStep(6)}>{t.yes}</button>
                  </div>
                )}
              </>
            )}
            {step === 6 && (
              <>
                {renderBotMessage(t.date)}
                {!typing && (
                  <select onChange={(e) => handleNext("date", e.target.value)}>
                    <option value="">--select--</option>
                    {dates.map((d, i) => (
                      <option key={i}>{d}</option>
                    ))}
                  </select>
                )}
              </>
            )}
            {step === 7 && (
              <>
                {renderBotMessage(t.time)}
                {!typing && (
                  <select onChange={(e) => handleNext("time", e.target.value)}>
                    <option value="">--select--</option>
                    {times.map((t, i) => (
                      <option key={i}>{t}</option>
                    ))}
                  </select>
                )}
              </>
            )}
            {step === 8 && (
              <>
                {renderBotMessage(t.confirm)}
                {!typing && (
                  <button className="email-btn" onClick={sendEmail}>
                    {t.sendEmail}
                  </button>
                )}
              </>
            )}
          </div>
          {step > 0 && (
            <div className="chat-footer">
              <button className="back-btn" onClick={handleBack}>
                {t.back}
              </button>
              
            </div>
          )}
        </div>
      )}
    </div>
  );
}
